import UserPrefs from '@/helpers/user-prefs';

export default {
    computed: {
        userPrefs() {
            return UserPrefs.loadFromLocalStorage();
        },
    },
};
